module.exports = __webpack_public_path__ + "static/img/item-three-scan.12a37fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/library/item-three-scan.png
// module id = GfxW
// module chunks = 2